module.exports = __webpack_public_path__ + "c281013d97ab40582d25f40f6edea82d.jpg";